(() => {
  if (window.__HL_SELECT_INIT__) return; // prevent double init
  window.__HL_SELECT_INIT__ = true;

  function initSelect(root) {
    const container = root.closest('[data-hl-select]');
    if (!container) return;

    const native = container.querySelector('.hl-select__native');
    const trigger = container.querySelector('.hl-select__trigger');
    const labelEl = container.querySelector('.hl-select__label');
    const dropdown = container.querySelector('.hl-select__dropdown');

    if (!native || !trigger || !dropdown || !labelEl) return;

    // Build dropdown from native options
    dropdown.innerHTML = '';
    const opts = Array.from(native.options);
    const frag = document.createDocumentFragment();
    opts.forEach((opt, idx) => {
      const li = document.createElement('li');
      li.className = 'hl-select__option';
      li.setAttribute('role', 'option');
      li.setAttribute('data-value', opt.value);
      li.setAttribute('aria-selected', opt.selected ? 'true' : 'false');
      if (opt.disabled) li.setAttribute('aria-disabled', 'true');
      li.textContent = opt.textContent || opt.value;
      frag.appendChild(li);
    });
    dropdown.appendChild(frag);

    function currentLabel() {
      const sel = native.selectedOptions && native.selectedOptions[0];
      return sel
        ? sel.textContent || sel.value
        : trigger.dataset.placeholder || '';
    }

    function open() {
      container.classList.add('hl-select--open');
      trigger.setAttribute('aria-expanded', 'true');
      dropdown.hidden = false;
    }

    function close() {
      container.classList.remove('hl-select--open');
      trigger.setAttribute('aria-expanded', 'false');
      dropdown.hidden = true;
    }

    function toggle() {
      if (container.classList.contains('hl-select--open')) close();
      else open();
    }

    function selectValue(value) {
      const prev = native.value;
      native.value = value;
      // update aria-selected in list
      dropdown.querySelectorAll('.hl-select__option').forEach((el) => {
        el.setAttribute(
          'aria-selected',
          el.getAttribute('data-value') === value ? 'true' : 'false',
        );
      });
      labelEl.textContent = currentLabel();
      if (prev !== value) {
        // dispatch change event for compatibility with existing code
        const evt = new Event('change', { bubbles: true });
        native.dispatchEvent(evt);
      }
      close();
    }

    // Bridge data-product-id from nearest wrappers if missing
    if (!native.dataset.productId) {
      const accItem = native.closest('.pd__accessories-item');
      const pid = accItem && accItem.dataset.productId;
      if (pid) native.dataset.productId = pid;
    }

    // Initial label
    labelEl.textContent = currentLabel();

    // Wire events
    trigger.addEventListener('click', (e) => {
      e.preventDefault();
      toggle();
    });

    dropdown.addEventListener('click', (e) => {
      const item = e.target.closest('.hl-select__option');
      if (!item || item.getAttribute('aria-disabled') === 'true') return;
      selectValue(item.getAttribute('data-value'));
    });

    // Sync if native changes programmatically
    native.addEventListener('change', () => {
      labelEl.textContent = currentLabel();
      dropdown.querySelectorAll('.hl-select__option').forEach((el) => {
        el.setAttribute(
          'aria-selected',
          el.getAttribute('data-value') === native.value ? 'true' : 'false',
        );
      });
    });

    // Close on outside click
    document.addEventListener('click', (evt) => {
      if (!container.contains(evt.target)) close();
    });

    // Basic keyboard support
    container.addEventListener('keydown', (e) => {
      const isOpen = container.classList.contains('hl-select--open');
      if (!isOpen && (e.key === 'Enter' || e.key === ' ')) {
        e.preventDefault();
        open();
        return;
      }
      if (isOpen) {
        if (e.key === 'Escape') {
          close();
          return;
        }
        const values = opts.filter((o) => !o.disabled).map((o) => o.value);
        const idx = values.indexOf(native.value);
        if (e.key === 'ArrowDown') {
          e.preventDefault();
          const next = values[Math.min(idx + 1, values.length - 1)];
          if (next != null) selectValue(next);
        } else if (e.key === 'ArrowUp') {
          e.preventDefault();
          const prev = values[Math.max(idx - 1, 0)];
          if (prev != null) selectValue(prev);
        } else if (e.key === 'Enter') {
          e.preventDefault();
          close();
        }
      }
    });
  }

  function autoInit() {
    document
      .querySelectorAll('[data-hl-select]')
      .forEach((el) => initSelect(el));
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', autoInit);
  } else {
    autoInit();
  }
})();
